export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.table_label_contactName') || '姓名',
    field: 'contactName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_contactJob') || '职位',
    field: 'contactJob',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_contactMobile') || '移动电话',
    field: 'contactMobile',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_contactPhone') || '办公电话',
    field: 'contactPhone',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_contactEmail') || '邮箱',
    field: 'contactEmail',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_contactDefaultFlag') || '默认联系人',
    field: 'contactDefaultFlag',
    align: 'center',
    width: 100,
    slots: { default: 'contactFlag' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_contactMemo') || '备注',
    field: 'contactMemo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
